import OnboardingLayout from './OnboardingLayout';
import { Button, colors, Typography } from '@sweep-io/sweep-design';
import PersonalEmailImg from './svgs/personalEmail.svg?react';
import { useCallback, useEffect } from 'react';
import { Stack } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { logoutUserBI } from '../../../services/mixpanel';

import { ArrowLeft } from '@sweep-io/sweep-design/dist/icons/ArrowLeft';

const PersonalEmailBlock = () => {
  const { error: authError, logout: auth0Logout } = useAuth0();
  const { appState } = (authError as any) ?? {}; //"appState" is not part of "Error" type, even though it IS returned as part of it.

  const onGoBackClick = useCallback((): void => {
    // Logout and redirect back to app with signup intent
    const returnTo = window.location.origin + '/?signup=true';
    logoutUserBI();
    auth0Logout({
      logoutParams: { returnTo },
    });
  }, [auth0Logout]);

  // Clean up URL by removing Auth0 error parameters and showing the intended destination
  useEffect(() => {
    window.history.replaceState({}, '', appState?.returnTo ?? window.location.pathname);
  }, [appState?.returnTo]);

  return (
    <OnboardingLayout withLogout={false}>
      <Stack alignItems="center" justifyContent="center" gap={3} textAlign="center">
        <PersonalEmailImg />
        <Stack gap={1} maxWidth="472px">
          <Typography variant="h1-medium">Please use a work email</Typography>
          <Typography variant="body" color={colors.grey[700]}>
            It looks like you entered a personal email. Please go back and use your work email to
            continue.
          </Typography>
        </Stack>
        <Button variant="primary" size="medium" startIcon={ArrowLeft} onClick={onGoBackClick}>
          Go back
        </Button>
      </Stack>
    </OnboardingLayout>
  );
};

export default PersonalEmailBlock;
